import React from "react";
import { Control, Controller } from "react-hook-form";

import SearchIcon from "public/icons/search-icon.svg";
import { z } from "zod";

import { styled, TextField as MuiTextField, css } from "@mui/material";

import { ButtonWithIcon } from "@/components/form/Button/ButtonWithIcon";
import { skipForwardProp } from "@/utils/skipForwardProp";
import { clsxm } from "@/utils/tailwindMerge";
import { withZodValidationOnChange } from "@/utils/validation.utils";

import { SearchInputsSchema } from "../models";

type PropTypes = {
  control: Control<SearchInputsSchema>;
};

type StyledTextFieldPropTypes = {
  highlightInput?: boolean;
};

const StyledTextField = styled(MuiTextField, {
  shouldForwardProp: skipForwardProp(["highlightInput"]),
})<StyledTextFieldPropTypes>(({ highlightInput, theme }) => {
  return css`
    ${highlightInput
      ? css`
          fieldset,
          fieldset:hover,
          .Mui-focused fieldset.MuiOutlinedInput-notchedOutline {
            border: 2px solid ${theme.palette.primary.main} !important;
            border-radius: 4px !important;
          }
        `
      : ""}
  `;
});

export const SearchLadyIdInput: React.FC<PropTypes> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="Id"
      defaultValue=""
      render={({ field: { value, onChange } }) => {
        return (
          <StyledTextField
            autoComplete={"false"}
            highlightInput={!!value}
            fullWidth
            label="Enter Lady's ID"
            InputProps={{ startAdornment: <IdTextFieldAdornment /> }}
            inputProps={{ inputMode: "numeric" }}
            value={value}
            onChange={withZodValidationOnChange(
              onChange,
              z
                .string()
                .max(10)
                .regex(/^[0-9]+$|^$/),
            )}
          />
        );
      }}
    />
  );
};

const IdTextFieldAdornment = () => {
  return (
    <ButtonWithIcon
      iconColor="light-grey"
      Icon={SearchIcon}
      type="submit"
      className={clsxm(
        "w-[2.2rem] h-[1.85rem] p-1",
        "mr-1",
        "shadow drop-shadow-sm shadow-grey1-50",
      )}
    />
  );
};
